// extracted by mini-css-extract-plugin
export default {"ingredients":"style_ingredients__QSBYK"};